import { track } from '../../services/analytics/analytics'
import { OnboardingCallCtaVariantId } from './onboarding-call-cta-variant'
import { OnboardingCallCtaPlacement } from './onboarding-call-cta-url'

const EXPERIMENT_KEY = 'onboarding-call-cta-ab'

export function trackOnboardingCallCtaClick(params: { placement: OnboardingCallCtaPlacement; abVariant: OnboardingCallCtaVariantId; companyId?: string; userId?: string }): void {
  const { placement, companyId, userId, abVariant } = params
  void track('ONBOARDING_CALL_CTA_CLICKED', {
    experiment_key: EXPERIMENT_KEY,
    ab_variant: abVariant,
    placement,
    ...(companyId ? { company_id: companyId } : {}),
    ...(userId ? { user_id: userId } : {}),
  })
}
